module.exports = __webpack_public_path__ + "static/nss-2b5560ad8bf75ee407864fe9db7377c7.svg";